(() => {
    'use strict';

    const init = () => {
        const Notice = document.querySelector(".site-cookie-notice");
        if (!Notice) return;

        const Confirm = Notice.querySelector("[data-cookieNotice='confirm']");
        if (!Confirm) return;

        // Adjust body padding and HTML scroll-padding based on the visibility of the cookie notice
        const updatePadding = () => {
            const outerHeight = Notice.offsetHeight;
            const paddingValue = Notice.style.display !== "none" ? `${outerHeight}px` : "0";
            document.body.style.paddingBottom = paddingValue;
            document.documentElement.style.scrollPaddingBottom = paddingValue;
        };

        updatePadding();

        Confirm.addEventListener("click", () => {
            Notice.style.transition = "all 0.2s";
            document.body.style.transition = "all 0.2s";
            document.documentElement.style.transition = "all 0.2s";
            Notice.style.height = "0";
            Notice.style.overflow = "hidden";

            setTimeout(() => {
                Notice.style.display = "none";
                document.body.style.paddingBottom = "0";
                document.documentElement.style.scrollPaddingBottom = "0";
            }, 200);

            setCookie("CookieNotice", "confirmed", Infinity, "/", window.location.hostname, window.location.protocol === "https:");
        });
    };

    const setCookie = (name, value, days, path = "/", domain = "", secure = false) => {
        const expires = days ? `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}` : "";
        document.cookie = `${name}=${value || ""}${expires}; path=${path}${domain ? `; domain=${domain}` : ""}${secure ? "; secure" : ""}`;
    };

    document.addEventListener("DOMContentLoaded", init);
})();
